var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.647,
    height: 19.92,
    viewBox: "0 0 23.647 19.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "blackTop",
    d: "M42.616,33.8a1.525,1.525,0,0,0-1.525-1.525H24.367l6.2-5.779a1.525,1.525,0,1,0-2.081-2.226l-9.031,8.413a1.525,1.525,0,0,0,0,2.23l9.031,8.417a1.525,1.525,0,0,0,2.081-2.23l-6.2-5.775H41.091A1.525,1.525,0,0,0,42.616,33.8Z",
    transform: "translate(-18.968 -23.822)",
    fill: "#5e2b97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackTop);
export default __webpack_public_path__ + "static/media/blackTop.3f92db3f827954aade1b09014be6f3f4.svg";
export { ForwardRef as ReactComponent };